import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    days: '{count} days',
    fortyFiveEndOfMonth: '45 days end of month',
    label: 'Payment terms',
    noDelay: 'Immediate payment',
    other: 'Other',
  },
  fr: {
    days: '{count} jours',
    fortyFiveEndOfMonth: '45 jours fin de mois',
    label: 'Délai de paiement',
    noDelay: 'Paiement immédiat',
    other: 'Autre',
  },
} as const);

export default locales;
